import React from 'react';
import { Truck, Package, Clock, MapPin } from 'lucide-react';

const Delivery = () => {
  return (
    <div className="min-h-screen bg-white pt-[73px]">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-serif mb-8 text-center">Çatdırılma</h1>

        <div className="prose prose-lg max-w-none">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="text-center p-6 border border-gray-200 rounded-lg">
              <Truck className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-serif mb-2"> Çatdırılma</h3>
              <p className="text-gray-600">Bakı üzrə 24 saat ərzində</p>
            </div>

            <div className="text-center p-6 border border-gray-200 rounded-lg">
              <Package className="w-12 h-12 mx-auto mb-4" />
              <h3 className="text-xl font-serif mb-2">Regionlara Çatdırılma</h3>
              <p className="text-gray-600">2-3 gün ərzində</p>
            </div>
          </div>

          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-serif mb-4">Çatdırılma Şərtləri</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <Clock className="w-5 h-5 mt-1 text-gray-600" />
                    <span>
                      <strong>Bakı üçün:</strong> Sifarişiniz 24 saat ərzində çatdırılır
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 mt-1 text-gray-600" />
                    <span>
                      <strong>Regionlar üçün:</strong> 2-3 iş günü ərzində çatdırılma
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Package className="w-5 h-5 mt-1 text-gray-600" />
                    <span>
                      <strong>Çatdırılma qiyməti:</strong> Poçt xərci alıcı tərəfindən ödənilir
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-serif mb-4">Sifariş Prosesi</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-black text-white rounded-full flex items-center justify-center font-bold">
                    1
                  </div>
                  <div>
                    <h3 className="font-medium mb-1">Məhsul seçimi</h3>
                    <p className="text-gray-600">
                      Bəyəndiyiniz məhsulu seçin və səbətə əlavə edin
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-black text-white rounded-full flex items-center justify-center font-bold">
                    2
                  </div>
                  <div>
                    <h3 className="font-medium mb-1">Məlumatların daxil edilməsi</h3>
                    <p className="text-gray-600">
                      Əlaqə nömrənizi və çatdırılma ünvanınızı daxil edin
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-black text-white rounded-full flex items-center justify-center font-bold">
                    3
                  </div>
                  <div>
                    <h3 className="font-medium mb-1">Təsdiq</h3>
                    <p className="text-gray-600">
                      Operatorumuz sifarişinizi təsdiqləmək üçün sizinlə əlaqə saxlayır
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-black text-white rounded-full flex items-center justify-center font-bold">
                    4
                  </div>
                  <div>
                    <h3 className="font-medium mb-1">Çatdırılma</h3>
                    <p className="text-gray-600">
                      Məhsulunuz göstərdiyiniz ünvana çatdırılır
                    </p>
                  </div>
                </div>
              </div>
            </section>

{/*             <section> */}
{/*               <h2 className="text-2xl font-serif mb-4">Qaytarma Siyasəti</h2> */}
{/*               <div className="bg-gray-50 p-6 rounded-lg"> */}
{/*                 <p className="text-gray-700 mb-3"> */}
{/*                   Məhsulu aldıqdan sonra 7 gün ərzində qaytarma imkanınız var. */}
{/*                 </p> */}
{/*                 <ul className="list-disc list-inside space-y-2 text-gray-600"> */}
{/*                   <li>Məhsul təzikdə və etiketlərlə birlikdə olmalıdır</li> */}
{/*                   <li>Məhsul istifadə edilməmiş olmalıdır</li> */}
{/*                   <li>Qaytarma pulsuz həyata keçirilir</li> */}
{/*                 </ul> */}
{/*               </div> */}
{/*             </section> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delivery;